module.exports = __webpack_public_path__ + "static/media/facebook.196e2fe4.svg";